import { render } from "./radioButton.vue?vue&type=template&id=497a2bd4"
import script from "./radioButton.vue?vue&type=script&lang=js"
export * from "./radioButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__